
const state = () => ({
  modals: [],
})

const getters = {
  modals: (state) => {
    return state.modals
  },
  modalsNames: (state) => {
    return state.modals.map(item => {
      if (typeof item === 'object') {
        return item.name
      }
      return item
    })
  },
  activeModal: (state) => {
    if (state.modals.length >= 0) {
      return state.modals[state.modals.length - 1]
    }
    return null
  },
  activeModalName: (state, getters) => {
    if (typeof getters.activeModal === 'object') {
      return getters.activeModal.name
    }
    return getters.activeModal
  },
}

const mutations = {
  openModal (state, modal) {
    let modalName = modal
    if (typeof modal === 'object') {
      modalName = modal.name
    }
    if (modalName) {
      const modalsNames = state.modals.map(item => {
        if (typeof item === 'object') {
          return item.name
        }
        return item
      })
      const index = modalsNames.indexOf(modalName)
      if (index >= 0) {
        state.modals.splice(index, 1)
      }
      state.modals.push(modal)
    }
  },
  closeModal (state, modalName) {
    if (modalName) {
      const modalsNames = state.modals.map(item => {
        if (typeof item === 'object') {
          return item.name
        }
        return item
      })
      const index = modalsNames.indexOf(modalName)
      state.modals.splice(index, 1)
    } else {
      state.modals.splice(state.modals.length - 1, 1)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}
